export default __webpack_public_path__ + "static/media/m-world.0c5ca335.png";